/**
 * Order Logs
 */

// React
import React, { useEffect, useContext, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';
import { getLogsAction, getOrderWithIdAction, getTPLLogsAction } from '../orders/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import { makeSelectLogs, makeSelectOrder, makeSelectTPLLogs } from '../orders/selectors';

//UI
import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Paper,
  Button,
  Grid,
  Divider,
} from '@material-ui/core';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from '@material-ui/lab';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiDotsHorizontalCircleOutline,
  mdiPackageVariantClosed,
  mdiTruckFastOutline,
  mdiMapMarkerCheckOutline,
  mdiClipboardAlertOutline,
  mdiClipboardArrowDownOutline,
  mdiClipboardCheckOutline,
  mdiClose,
  mdiAccountOutline,
  mdiCardAccountPhoneOutline,
  mdiCalendarRange,
  mdiPackageVariant,
  mdiKeyOutline,
  mdiMapMarkerRadiusOutline,
  mdiPlusBoxMultipleOutline,
  mdiAccountArrowRight,
  mdiArrowDownThick,
  mdiArrowUpThick,
} from '@mdi/js';

// Helper
import {
  translate,
  formaterPhoneNumber,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';
import Can from '../../components/Can';

// Type
import { Log } from '../orders/interfaces';
import { SelectorProps, Props } from './interfaces';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    secondaryTail: {
      backgroundColor: theme.palette.secondary.main,
    },
    paperHistory: {
      '@media (min-width: 768px)': {
        width: '40%',
      },
    },
    headerBox: {
      display: 'flex',

      alignItems: 'center',
      marginBottom: '28px',
    },
    titleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: '4px 4px 0 0',
    },
    contentBox: {
      padding: theme.spacing(2),
      fontSize: '14px',
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paper: {
      marginTop: theme.spacing(4),
      marginBottom: '36px',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      border: '1px solid #ddd',
      borderRadius: '4px 4px 0 0',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      '& > *': {
        margin: theme.spacing(0, 1),
      },
    },
    divider: {
      width: '97%',
      margin: '0 auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
  })
);

//const
const iconStatus = {
  ARRIVED: mdiMapMarkerCheckOutline, //'به مقصد رسیده',
  BUNDLED: mdiPackageVariantClosed, //' بسته‌بندی شده برای راننده',
  CANCELLED: mdiClose, //'لغو شده',
  DELIVERED_TO_POST: mdiDotsHorizontalCircleOutline, //'ارسال شده',
  DELIVERED_TO_CENTER: mdiDotsHorizontalCircleOutline, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: mdiDotsHorizontalCircleOutline, //'تامین در مرکز',
  PACKAGED: mdiPackageVariant, //'بسته بندی شده برای مشتری',
  DELIVERED: mdiClipboardCheckOutline, //'تحویل داده شده',
  LOADED: mdiTruckFastOutline, // 'در حال تحویل',
  NOT_DELIVERED: mdiClipboardAlertOutline, //'تحویل داده نشده',
  ORDERED: mdiDotsHorizontalCircleOutline, //'ایجاد شده',
  RETURNED: mdiClipboardArrowDownOutline, //'بازگردانده شده',
  PICKED: mdiPlusBoxMultipleOutline, //'برداشته شده',
  ASSIGNED: mdiAccountArrowRight, //'برداشته شده',
};
const colorStatus = {
  ARRIVED: theme.palette.green.main, //'به مقصد رسیده',
  BUNDLED: theme.palette.green.main, //' بسته‌بندی شده برای راننده',
  CANCELLED: theme.palette.error.main, //'لغو شده',
  DELIVERED_TO_POST: theme.palette.green.main, //'ارسال شده',
  DELIVERED_TO_CENTER: theme.palette.green.main, //'تحویل در مرکز',
  SUPPLIED_IN_CENTER: theme.palette.green.main, //'تامین در مرکز',
  PACKAGED: theme.palette.green.main, //'بسته بندی شده برای مشتری',
  DELIVERED: theme.palette.green.main, //'تحویل داده شده',
  LOADED: theme.palette.green.main, // 'در حال تحویل',
  NOT_DELIVERED: theme.palette.orange.main, //'تحویل داده نشده',
  ORDERED: theme.palette.green.main, //'ایجاد شده',
  RETURNED: theme.palette.neutral.main, //'بازگردانده شده',
  PICKED: theme.palette.orange.main, //'بازگردانده شده',
  ASSIGNED: theme.palette.blue.main, //'بازگردانده شده',
};

export function Logs(props: Props) {
  const authContext = useContext(AuthContext);

  const classes = useStyles();

  const [moreDetails, setMoreDetails] = useState<boolean>(false);
  const [typeOfIndex, setTypeOfIndex] = useState<number>();
  const [filterValue, setFilterValue] = useState();
  useEffect(() => {
    const { id } = props.match.params;
    props.getLogsDispatch(id);
    props.orderWithIdActionDispatch(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const moreDetailsClickHandler = (index, UUID) => {
    setMoreDetails(!moreDetails);
    setTypeOfIndex(index);
    if (!moreDetails) {

      props.getTPLLogsDispatch({ 'tplOrderUUID.equals': UUID })
    }
  };
  return (
    <div>
      <div className={classes.headerBox}>
        <Typography
          variant="h6"
          component="div"
          style={{ marginLeft: '20px', fontSize: '18px' }}
        >
          {`تاریخچه سفارش`}
        </Typography>
        <span className={classes.contentlabelTitle}>
          {props.match.params?.id}
        </span>
      </div>
      <Button
        aria-label="details"
        size="medium"
        onClick={() => window.history.back()}
      >
        <Icon path={mdiArrowRight} size={1} className={classes.icon} />
        {`بازگشت`}
      </Button>

      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {`نام سفارش‌دهنده:  `}
              </span>

              <span>{props.order.customerName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCardAccountPhoneOutline}
                  size={1}
                  className={classes.icon}
                />
                {`شماره همراه سفارش‌دهنده:  `}
              </span>
              <span>
                {formaterPhoneNumber(props.order.customerPhoneNumber)}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarRange}
                  size={1}
                  className={classes.icon}
                />
                {`زمان تحویل:  `}
              </span>
              <span>
                {props.order.deliveryDate &&
                  jMoment(props.order.deliveryDate, 'YYYY/MM/DD')
                    .locale('fa')
                    .format('jYYYY/jMM/jDD')}
              </span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPackageVariant}
                  size={1}
                  className={classes.icon}
                />
                {`شناسه سفارش:  `}
              </span>
              <span>{props.order.id}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          {props.order.bundleId && (
            <Can
              role={authContext.user.role}
              perform="orders:byBundle"
              yes={() => (
                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiKeyOutline}
                        size={1}
                        className={classes.icon}
                      />
                      {`شناسه بسته :  `}
                    </span>
                    <Link to={`/bundles/${props.order.bundleId}`}>
                      <span>{props.order.bundleId}</span>
                    </Link>
                  </div>
                </Grid>
              )}
            />
          )}
          <Grid item xs={12} sm={6}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerRadiusOutline}
                  size={1}
                  className={classes.icon}
                />
                {` نام مرکز:  `}
              </span>
              <span>{props.order.centerName}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Grid container>
        <Grid item xs={12}>
          <Timeline align="left">
            {props.logs
              ?.slice()
              .reverse()
              .map((log: Log, index: number) => (
                <TimelineItem
                  className={classes.missingOppositeContent}
                  key={index}
                >
                  <TimelineSeparator>
                    <TimelineDot
                      style={{
                        backgroundColor: colorStatus[log.newStatus],
                        borderColor:
                          index === 0 ? theme.palette.secondary.main : '',
                      }}
                    >
                      <Icon path={iconStatus[log.newStatus]} size={1} />
                    </TimelineDot>
                    {index !== props.logs?.length - 1 ? (
                      <TimelineConnector />
                    ) : (
                      ''
                    )}
                  </TimelineSeparator>
                  <TimelineContent>
                    <Paper
                      key={index}
                      elevation={3}
                      className={classes.paperHistory}
                    >
                      <Typography component="div" className={classes.titleBox}>
                        {log.time &&
                          jMoment(log.time, 'YYYY/MM/DDTHH:mm:ss.SSZ')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD - HH:mm')}
                      </Typography>
                      <div className={classes.contentBox}>
                        <div>
                          <span className={classes.contentlabel}>
                            وضعیت سفارش:
                          </span>
                          <span>{translate(log.newStatus, 'order')}</span>
                        </div>
                        <div className={classes.contentBox}>
                          <span className={classes.contentlabel}>
                            {log.driverName
                              ? 'نام راننده :'
                              : log.orderTPLType
                                ? 'نام کوریر :'
                                : null}
                          </span>
                          <span>
                            {' '}
                            {log.driverName
                              ? log.driverName
                              : log.orderTPLType
                                ? log.orderTPLType
                                : null}{' '}
                          </span>
                        </div>
                        <div style={{ marginTop: '12px' }}>
                          <span className={classes.contentlabel}>کاربر:</span>
                          <Can
                            role={authContext.user.role}
                            perform="user-name:dontShowInLogs"
                            no={() => (
                              <>
                                <span>{log.modifierName}</span>
                                <span> &nbsp; &nbsp;- &nbsp; &nbsp;</span>
                              </>
                            )}
                          />
                          <span>{translate(log.modifierRole, 'user')}</span>
                        </div>
                        {log.description && (
                          <div style={{ marginTop: '12px' }}>
                            <span className={classes.contentlabel}>
                              توضیحات:
                            </span>
                            <span>{log.description}</span>
                          </div>
                        )}
                      </div>
                      {
                        log.tplOrderUUID && (
                          <Button
                            aria-label="details"
                            size="medium"
                            data-cy={index}
                            onClick={() => moreDetailsClickHandler(index, log.tplOrderUUID)}
                          >
                            <Icon
                              path={
                                moreDetails && typeOfIndex === index ? mdiArrowUpThick : mdiArrowDownThick
                              }
                              size={1}
                              className={classes.icon}
                            />
                            {'بیشتر'}
                          </Button>
                        )
                      }


                      {
                        moreDetails && typeOfIndex === index && (
                          props.tplLogs?.map((tplLog, index) => {
                            return (

                              <div className={classes.contentBox}>
                                <div>
                                  <span className={classes.contentlabel}>
                                    شناسه بسته:
                                  </span>
                                  <span>{tplLog?.tplOrderId}</span>
                                </div>
                                <div>
                                  <span className={classes.contentlabel}>
                                    وضعیت بسته:
                                  </span>
                                  <span>{translate(tplLog?.newStatus, 'order')}</span>
                                </div>
                              </div>
                            )
                          })
                        )
                      }

                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              ))}
          </Timeline>
        </Grid>
      </Grid>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  logs: makeSelectLogs(),
  tplLogs: makeSelectTPLLogs(),
  order: makeSelectOrder(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getLogsDispatch: (id: number) => dispatch(getLogsAction({ id })),
    orderWithIdActionDispatch: (id: number) =>
      dispatch(getOrderWithIdAction({ id })),
    getTPLLogsDispatch: (payload) => dispatch(getTPLLogsAction(payload))
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Logs);
